import controller from './categories-synchronous-filter.controller';
import templateBase from './templates/categories-synchronous-filter-base.view.html';

let CategoriesSynchronousFilterComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default CategoriesSynchronousFilterComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-synchronous-filter/categories-synchronous-filter.component.js
 **/